import { useState, useEffect, useCallback } from 'react';
import { search } from '../api/search';
import { SearchResults } from '../types/index';

interface UseSearchReturn {
  results: SearchResults | null;
  isLoading: boolean;
  error: Error | null;
}

const DEBOUNCE_DELAY = 300;

export const useSearch = (query: string): UseSearchReturn => {
  const [results, setResults] = useState<SearchResults | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!query.trim()) {
      setResults(null);
      return;
    }

    const timer = setTimeout(async () => {
      setIsLoading(true);
      setError(null);

      try {
        const data = await search(query);
        setResults(data);
      } catch (err) {
        const error = err instanceof Error ? err : new Error('Search failed');
        setError(error);
      } finally {
        setIsLoading(false);
      }
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(timer);
  }, [query]);

  return { results, isLoading, error };
};
